// pages/admins/permissions/PermissionSourceBadge.jsx
//
// Renders WHERE a permission's current value comes from -- the Role, a
// User Override, or a System/no-grant default -- as one small icon+color
// pill. Paired with PermissionStateBadge (WHAT the value is) instead of one
// blended badge, so "this is inherited from the role" vs. "this was
// deliberately overridden for this one user" is visually obvious at a
// glance, per the legend (blue = Role, purple = User Override).
import React from "react";
import { Badge } from "react-bootstrap";

const SOURCE_META = {
  ROLE: { label: "Role", icon: "fa-diagram-project", cls: "pm-source-role" },
  OVERRIDE: { label: "User Override", icon: "fa-user-pen", cls: "pm-source-override" },
  SYSTEM: { label: "System", icon: "fa-gear", cls: "pm-source-system" },
};

export default function PermissionSourceBadge({ source, label, size = "md" }) {
  const meta = SOURCE_META[source] || SOURCE_META.SYSTEM;
  return (
    <Badge bg={null} className={`pm-source-badge ${meta.cls} pm-source-badge-${size}`}>
      <i className={`fa-solid ${meta.icon}`} aria-hidden="true"></i>
      {label || meta.label}
    </Badge>
  );
}

export { SOURCE_META };
